module.exports = __webpack_public_path__ + "img/fulfilment-ratio-tag.e136ebb.svg";